import { Component, Input, OnInit } from '@angular/core';
import * as moment from 'moment';
import { CalendarWeek } from '../../pages/global/wochenuebersicht/wochenuebersicht.page';
import { LoggerService } from '../../ax-commons-logger/logger/logger.service';
import { AxUiService } from '../../services/ax-ui.service';
import {
  WorkMontageplanDayDto,
  WorkMontageplanUsersTeamPartial,
  WorkMontageplanV2Service,
  WorkTask,
  WorkTimerecordtypeNameEnum,
} from '../../_generated/work-rest-api';

@Component({
  selector: 'ax-tagesuebersicht-card',
  templateUrl: './ax-tagesuebersicht-card.component.html',
  styleUrls: ['./ax-tagesuebersicht-card.component.scss'],
})
export class AxTagesuebersichtCardComponent implements OnInit {
  @Input() montageplanDayDto: WorkMontageplanDayDto;
  @Input() selectedCalendarWeek: CalendarWeek | undefined;
  public montageplanUsersTeamPartial: WorkMontageplanUsersTeamPartial[] = [];
  public isEntireTeamAbsent = false;
  public taskProjectInfos: Record<number, string> = {};
  protected axTimerecordtypeNameEnum = WorkTimerecordtypeNameEnum;
  protected readonly moment = moment;

  constructor(
    private readonly axMontageplanV2Service: WorkMontageplanV2Service,
    private readonly axUiService: AxUiService,
  ) {
  }

  public async ngOnInit() {
    this.taskProjectInfos = this.getTaskProjectInfos(this.montageplanDayDto?.teams?.[0]?.tasks ?? []);
    await this.loadTeamData();
  }

  /**
   * Projektnummer, Nachname (bzw. Firma) des Kunden und Ort pro Aufgabe — gleiche Darstellung wie `projectName` und
   * `customerName` der Projekt-Blöcke.
   *
   * @param tasks
   * @private
   */
  private getTaskProjectInfos(tasks: WorkTask[]): Record<number, string> {
    const taskProjectInfos: Record<number, string> = {};
    tasks.forEach(task => {
      const project = task.project;
      const contact = project?.container?.contact;
      if (!project) {
        return;
      }
      const customerName = contact?.company ? contact.company : contact?.lastName;
      const city = project.objectCity ? project.objectCity : contact?.city;
      const customerNameParts = [customerName, city].filter(customerNamePart => !!customerNamePart);
      const projectInfoParts = [project.numberQualified, customerNameParts.join(', ')].filter(
        projectInfoPart => !!projectInfoPart,
      );
      if (projectInfoParts.length) {
        taskProjectInfos[task.id] = projectInfoParts.join(' · ');
      }
    });
    return taskProjectInfos;
  }


  private async loadTeamData() {
    try {
      const teamId = this.montageplanDayDto.teams[0].teamId;
      const montageplanUsersDto = await this.axMontageplanV2Service.montageplanV2ControllerGetMontageplanUsersByTeamIdAndDaterange({
        fromDate: this.montageplanDayDto.date,
        toDate: this.montageplanDayDto.date,
        teamIds: [`${teamId}`],
      }).toPromise();
      this.montageplanUsersTeamPartial = montageplanUsersDto.teams[teamId];
      this.isEntireTeamAbsent = this.getIsEntireTeamAbsent(this.montageplanUsersTeamPartial, this.montageplanDayDto.date);
    } catch (dataNotLoadedException) {
      LoggerService.ERROR(this, 'dataNotLoadedException', dataNotLoadedException);
      if (dataNotLoadedException.status === 403 || dataNotLoadedException.status === '403') {
        await this.axUiService.showError('Kein Zugriff auf den Teams.');
      }
    }
  }

  private getIsEntireTeamAbsent(montageplanUsersTeamPartials: WorkMontageplanUsersTeamPartial[], date: string) {
    let isAbsent = true;
    montageplanUsersTeamPartials.forEach(usersTeamPartial => {
      if (usersTeamPartial.timerecords[date].timerecordtypeName === WorkTimerecordtypeNameEnum.Arbeit) {
        isAbsent = false;
      }
    });
    return isAbsent;
  }
}
